"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import posthog from "posthog-js";
interface PostHogPageViewProps {
  enabled: boolean;
  posthogKey?: string;
}

/**
 * Component that tracks page views using PostHog.
 * Must be wrapped in Suspense boundary due to useSearchParams().
 */
export function PostHogPageView(t0) {
  const $ = _c(6);
  const {
    enabled,
    posthogKey
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  let t2;
  if ($[0] !== enabled || $[1] !== pathname || $[2] !== posthogKey || $[3] !== searchParams) {
    t1 = () => {
      if (enabled && pathname && posthogKey) {
        let url = window.origin + pathname;
        if (searchParams?.toString()) {
          url = url + `?${searchParams.toString()}`;
        }
        posthog.capture("$pageview", {
          $current_url: url
        });
      }
    };
    t2 = [pathname, searchParams, enabled, posthogKey];
    $[0] = enabled;
    $[1] = pathname;
    $[2] = posthogKey;
    $[3] = searchParams;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  return null;
}